import React from "react";

const EventIcons = ({
    background = "#484848",
    backgroundImage = '',
    icon,
    marginRight = 10,
    borderRadius = 5,
    height = 20,
    width = 20,
    fontWeight = "normal"
}) => {
  return (
    <div
      style={{
        background: background,
        backgroundImage: background,
        height: height,
        width: width,
        borderRadius: borderRadius,
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: marginRight,
        fontWeight: fontWeight
      }}
    >
      {icon}
    </div>
  );
};

export default EventIcons;
